import { FaqItems } from "./types";

export const faqItems: FaqItems = [
  {
    question: "How do I register with Keyzy?",
    answer:
      "It’s easy! Just sign up here and give us a little information about yourself and your company. Someone from Keyzy will be in touch to have an onboarding call with you. After that you’ll get access to your dashboard and can start making referrals.",
  },
  {
    question: "How do I refer my client to join Keyzy?",
    answer:
      "After you’ve registered and have access to your Partner Portal you can make referrals there. It only takes 90 seconds and you’ll need some basic information about your client like their income and loan commitments. When you send us a referral we will contact your client to give them their Budget in Principle and we take care of the rest!",
  },
  {
    question: "What are the basic eligibility criteria for my client?",
    answer:
      "Your client will need a combined household income of at least £50,000, no recent history of IVAs, CCJs or bankruptcy, and have the right to live and work in the UK. They will need to be in their currently employment for at least three months (12 months for self-employed).",
  },
  {
    question: "What are the fees for my client?",
    answer:
      "We are a zero deposit solution. We charge a one-off future buyback sum of £499 for 1 applicant, £999 for 2 applicants, or £1,499 for 3 or more applicants before moving in.",
  },
  {
    question: "What procurement fee does Keyzy pay?",
    answer:
      "Procurement fees and the terms for working with Keyzy will all be discussed in your onboarding call.",
  },
];
